import { render, staticRenderFns } from "./mod-details.vue?vue&type=template&id=db0b3180&scoped=true&"
import script from "./mod-details.vue?vue&type=script&lang=js&"
export * from "./mod-details.vue?vue&type=script&lang=js&"
import style0 from "./mod-details.vue?vue&type=style&index=0&id=db0b3180&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db0b3180",
  null
  
)

export default component.exports